import { render } from "./myHead.vue?vue&type=template&id=6fccc9e3&scoped=true"
import script from "./myHead.vue?vue&type=script&lang=js"
export * from "./myHead.vue?vue&type=script&lang=js"

import "./myHead.vue?vue&type=style&index=0&id=6fccc9e3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\28950\\source\\repos\\xtz\\hql\\bm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fccc9e3"]])

export default __exports__